import { IParlamentarianAddEditRequest } from '../../../../model/sge/parlamentarian/request/parlamentarian-add-edit-request';
import { IParlamentarianResponse } from '../../../../model/sge/parlamentarian/response/parlamentarian-response';
import { ValidationErrors, isBlank, isEmptyId } from '../../../../utils/validation';

export const PARLAMENTARIAN_TYPES = [
    { value: 1, label: 'Deputado Estadual' },
    { value: 2, label: 'Deputado Federal' },
    { value: 3, label: 'Senador' },
];

export function getParlamentarianTypeLabel(type?: number | string): string {
    if (type === undefined || type === null || type === '') return '';
    return PARLAMENTARIAN_TYPES.find((t) => t.value === Number(type))?.label ?? String(type);
}

export type ParlamentarianField = 'name' | 'type';

export function toParlamentarianForm(data?: IParlamentarianResponse): IParlamentarianAddEditRequest {
    if (!data) return { isActive: true, contact: {} };
    return {
        name: data.personName,
        type: data.type ? Number(data.type) : undefined,
        politicalPartyId: data.politicalPartyId,
        isActive: data.isActive,
        contact: {
            email: data.contactEmail,
            phone: data.contactPhone,
            mobile: data.contactMobile,
            commercialPhone: data.contactCommercialPhone,
        },
    };
}

export function validateParlamentarian(form: IParlamentarianAddEditRequest): ValidationErrors<ParlamentarianField> {
    const errors: ValidationErrors<ParlamentarianField> = {};
    if (isBlank(form.name)) errors.name = 'Nome é obrigatório';
    if (isEmptyId(form.type)) errors.type = 'Tipo é obrigatório';
    return errors;
}
